<template>
  <div>
    <Grid
      :service="service"
      route_name="teacher_revenue"
      route_grid_path="/grid"
      order_column="order_date"
      direction="desc"
      :show-export="true"
      :export-types="['csv', 'xls']"
      export-filename="hubee_teacher_revenue"
      :fetch-on-mounted="false"
      hide_actions="true"
      hide_searchbar="true"
      ref="grid"
    >
      <template v-slot:filterZone>
        <FinancialPeriodFilter
          v-model="filters"
          @change="handleFilterChange"
          :show-people-filter="true"
          :show-institution-filter="false"
          people-filter-type="teacher"
        />
      </template>

      <template v-slot:gridThead>
        <vs-th key="teacher_name" sort-key="teacher_name">Professor</vs-th>
        <vs-th key="teacher_email" sort-key="teacher_email"
          >Email do Professor</vs-th
        >
        <vs-th key="order_id" sort-key="order_id">ID Pedido</vs-th>
        <vs-th key="order_date" sort-key="order_date">Data do Pedido</vs-th>
        <vs-th key="payment_date" sort-key="payment_date"
          >Data do Pagamento</vs-th
        >
        <vs-th key="payment_status" sort-key="payment_status"
          >Status do Pagamento</vs-th
        >
        <vs-th key="total_amount" sort-key="total_amount">Valor Total</vs-th>
        <vs-th key="paid_amount" sort-key="paid_amount">Valor Recebido</vs-th>
      </template>

      <template v-slot:gridData="props">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in props.data">
          <vs-td width="15%" key="teacher_name">
            <div class="font-semibold">{{ tr.teacher_name }}</div>
          </vs-td>
          <vs-td width="15%" key="teacher_email">
            <div>{{ tr.teacher_email }}</div>
          </vs-td>
          <vs-td width="8%" key="order_id">
            <div>{{ tr.order_id }}</div>
          </vs-td>
          <vs-td width="12%" key="order_date">
            <div>{{ formatDate(tr.order_date) }}</div>
          </vs-td>
          <vs-td width="12%" key="payment_date">
            <div>{{ formatDate(tr.payment_date) }}</div>
          </vs-td>
          <vs-td width="12%" key="payment_status">
            <div>{{ formatPaymentStatus(tr.payment_status) }}</div>
          </vs-td>
          <vs-td width="13%" key="total_amount">
            <span class="font-semibold">{{
              formatCurrency(tr.total_amount)
            }}</span>
          </vs-td>
          <vs-td width="13%" key="paid_amount">
            <span class="font-semibold text-success">{{
              formatCurrency(tr.paid_amount)
            }}</span>
          </vs-td>
        </vs-tr>
      </template>
    </Grid>
  </div>
</template>

<script>
import Grid from '@/components/Grid.vue'
import FinancialPeriodFilter from '@/components/filters/FinancialPeriodFilter.vue'
import TeacherRevenueService from '@/services/api/TeacherRevenueService'
import { currencyFormatter } from '@/util/Util'

export default {
  name: 'TeacherRevenueIndex',
  components: {
    Grid,
    FinancialPeriodFilter
  },
  data() {
    return {
      service: null,
      filters: {
        institution_id: null,
        start_date: null,
        end_date: null,
        teacher_id: null
      }
    }
  },
  methods: {
    formatCurrency(value) {
      return currencyFormatter(value)
    },
    formatDate(value) {
      if (!value) return 'N/A'
      const date = new Date(value)
      return date.toLocaleDateString('pt-BR')
    },
    formatPaymentStatus(status) {
      const statusMap = {
        PE: 'Pendente',
        PR: 'Em Processamento',
        PA: 'Pago',
        RE: 'Recusado',
        CA: 'Cancelado'
      }
      return statusMap[status] || status
    },
    handleFilterChange(filters) {
      this.filters = filters
      this.updateFilters()
    },
    updateFilters() {
      const customFilters = {}

      if (this.filters.start_date) {
        customFilters.start_date = this.filters.start_date
      }

      if (this.filters.end_date) {
        customFilters.end_date = this.filters.end_date
      }

      if (this.filters.teacher_id) {
        customFilters.teacher_id = this.filters.teacher_id
      }

      // Limpar todos os custom_filters primeiro
      this.$refs.grid.custom_filters = []

      // Preencher apenas os filtros que têm valores
      if (Object.keys(customFilters).length > 0) {
        this.$refs.grid.fillCustomFilters(
          Object.keys(customFilters).map(key => ({
            key,
            value: customFilters[key]
          }))
        )
      }

      this.$refs.grid.fetchGridData(true)
    }
  },
  beforeMount() {
    this.service = TeacherRevenueService.build(this.$vs)
  }
}
</script>

<style scoped>
.vs-select {
  min-width: 200px;
}
</style>
